import React from "react";
import { Button } from "@vds/buttons";

const NoSlotsAvailableModal = ({ show, onClose, onConfirm }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "32px 28px 24px 28px",
          minWidth: "340px",
          maxWidth: "480px",
          width: "100%",
          boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
          position: "relative",
        }}
      >
        {/* Close X */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "16px",
            background: "none",
            border: "none",
            fontSize: "18px",
            cursor: "pointer",
            color: "#333",
            lineHeight: 1,
          }}
          aria-label="Close"
        >
          ✕
        </button>

        <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "8px", marginTop: 0 }}>No Slots Available</h2>
        <p style={{ fontSize: "13px", color: "#555", marginBottom: "24px", marginTop: 0 }}>Please switch to Manual Schedule.</p>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <Button use="secondary" size="small" onClick={onConfirm}>
            Ok
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoSlotsAvailableModal;
